import { maxBy } from 'lodash';

import { isAfterOrEqualTo, jsPlainDateToTemporalPlainDate, Qrpc, Temporal } from '@willow/types-iso';

export function getMostRecentQrpcEntrySince(entries: Qrpc[], sinceDate: Temporal.PlainDate): Qrpc | undefined {
  const mostRecentEntry = maxBy(entries, (entry) => entry.date.getTime());
  if (mostRecentEntry == null) {
    return undefined;
  }
  const mostRecentEntryPlainDate = jsPlainDateToTemporalPlainDate(mostRecentEntry.date);
  return isAfterOrEqualTo(mostRecentEntryPlainDate, sinceDate) ? mostRecentEntry : undefined;
}
